import apiConfig from "../ApiConfig";

export const getDocumentFrameworksRoleBasedApi = async (
  page = 1,
  pageSize = 20,
  query = ""
) => {
  const res = await apiConfig.get(
    `/api/document-library/frameworks/role-based/?page=${page}&page_size=${pageSize}&${query}`
  );
  return res.data;
};

export const getDocumentFrameworksCustomerAdminApi = async (
  page = 1,
  pageSize = 20,
  customer_id = "",
  query = ""
) => {
  const res = await apiConfig.get(
    `/api/document-library/frameworks/customer-admin/?page=${page}&page_size=${pageSize}&customer_id=${customer_id}&${query}`
  );
  return res.data;
};

export const getDocumentFrameworksEmployeeApi = async (
  page = 1,
  pageSize = 20,
  employee_id = "",
  query = ""
) => {
  const res = await apiConfig.get(
    `/api/document-library/frameworks/employee/?page=${page}&page_size=${pageSize}&employee_id=${employee_id}&${query}`
  );
  return res.data;
};

export const getUserDocumentFrameworksApi = async () => {
  const res = await apiConfig.get(`/api/document-library/user-frameworks/`);
  const frameworks = Array.isArray(res?.data?.framework) ? res.data.framework : [];
  return {
    ...res.data,
    results: frameworks,
    count: res?.data?.len ?? frameworks.length,
    total_pages: 1,
  };
}


// ===============================
// Document Library – Dashboard & Documents
// ===============================

// 📊 Compliance dashboard stats
export const getComplianceStatsApi = async () => {
  const res = await apiConfig.get(
    "/api/document-library/compliance-stats/"
  );
  return res.data;
};


// 📄 Fetch documents list with filters
export const getDocumentsApi = async (queryString = "") => {
  const res = await apiConfig.get(
    `/api/document-library/documents/?${queryString}`
  );
  return res.data;
};


// ===============================
// Create Document
// ===============================

export const createDocumentApi = async (payload) => {
  const res = await apiConfig.post(
    "/api/document-library/documents",
    payload
  );
  return res.data;
};


// ===============================
// Document Library – Export & Details
// ===============================

// 📤 Export document library
export const exportDocumentsApi = async (format = "csv", token) => {
  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/document-library/export?format=${format}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error("Export failed");
  }

  return res.blob(); // 🔥 return blob for download
};



export const getMyLibrariesApi = async (
  page = 1,
  pageSize = 20,
  customerId = "",
  employeeId = ""
) => {
  const employeeParam = employeeId ? `&employee_id=${employeeId}` : "";
  const res = await apiConfig.get(
    `/api/document-library/my-libraries/?page=${page}&page_size=${pageSize}&customer_id=${customerId}${employeeParam}`
  );
  return res.data;
};

export const updateDocumentAcknowledgementApi = async ({
  employee_id,
  sub_category_id,
  control_id,
  is_acknowledge,
}) => {
  const res = await apiConfig.post(
    "/api/document-library/document-acknowledgement/update/",
    {
      employee_id,
      sub_category_id,
      control_id,
      is_acknowledge,
    }
  );
  return res.data;
};

export const getNotReadyForAuditApi = async (page, pageSize, filters = {}) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  if (filters.search) params.set('search', filters.search);
  if (filters.framework_id) params.set('framework_id', filters.framework_id);
  if (filters.category) params.set('category', filters.category);
  if (filters.customer_id) params.set('customer_id', filters.customer_id);
  const res = await apiConfig.get(
    `/api/document-library/not-ready-for-audit/?${params}`  
  );
  return res.data;
};

export const getReadyForAuditApi = async (page, pageSize, filters = {}) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  if (filters.search) params.set('search', filters.search);
  if (filters.framework_id) params.set('framework_id', filters.framework_id);
  if (filters.category) params.set('category', filters.category);
  if (filters.customer_id) params.set('customer_id', filters.customer_id);
  const res = await apiConfig.get(
    `/api/document-library/ready-for-audit/?${params}`
  );
  return res.data;
};
export const getFlaggedByAuditorApi = async (page, pageSize, filters = {}) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  if (filters.search) params.set('search', filters.search);
  if (filters.framework_id) params.set('framework_id', filters.framework_id);
  if (filters.category) params.set('category', filters.category);
  if (filters.customer_id) params.set('customer_id', filters.customer_id);  
  const res = await apiConfig.get(
    `/api/document-library/flagged-by-auditor/?${params}`
  );
  return res.data;
}
export const getAcceptedByAuditorApi =  async (page, pageSize, filters = {}) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  if (filters.search) params.set('search', filters.search);
  if (filters.framework_id) params.set('framework_id', filters.framework_id);
  if (filters.category) params.set('category', filters.category);
  if (filters.customer_id) params.set('customer_id', filters.customer_id);
  const res = await apiConfig.get(
    `/api/document-library/accepted-by-auditor/?${params}`
  );
  return res.data;
}
export const getNotApplicableApi = async (page, pageSize, filters = {}) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  if (filters.search) params.set('search', filters.search);
  if (filters.framework_id) params.set('framework_id', filters.framework_id);
  if (filters.category) params.set('category', filters.category);
  if (filters.customer_id) params.set('customer_id', filters.customer_id);
  const res = await apiConfig.get(
    `/api/document-library/not-applicable/?${params}`
  );
  return res.data;
}

